module.exports = __webpack_public_path__ + "img/dashboard.54bbecba.svg";